import { Navigate } from 'react-router'

import useUser from 'src/core/contexts/UserContext/hooks/useUser'
import type { FeatureFlag } from 'src/core/contexts/UserContext/types'
import { ROUTES } from 'src/routes'

interface Props {
	featureFlag: FeatureFlag
	element: React.ReactNode
}

const FFProtectedRoute = (props: Props) => {
	const { featureFlag, element } = props

	const { user, loadingUser } = useUser()

	if (loadingUser) {
		return null
	}

	const { featureFlags } = user || {}
	const noAccess = featureFlags?.[featureFlag as FeatureFlag] === false

	if (noAccess) {
		return <Navigate to={ROUTES.PAID_FEATURE} replace />
	}

	return <>{element}</>
}

export default FFProtectedRoute
